import { COMPANY_TYPE } from '../../../../constants/app';
import getCurrentUserId from '../../../../ui-framework/helpers/getCurrentUserId';

const MANAGED_PREFERENCE_ROLES = ['SUPERVISOR', 'IMPLEMENTATION_MANAGER'];

const canManageUserNotificationPreferences = (
  userAccess,
  targetCompanyType,
) => {
  if (!userAccess || !Object.values(COMPANY_TYPE).includes(targetCompanyType)) {
    return false;
  }
  const isAdmin =
    typeof userAccess.isAdmin === 'function' && userAccess.isAdmin();
  const roleIdentifier =
    userAccess?.role?.roleIdentifier || userAccess?.user?.role?.roleIdentifier;
  return (
    !!isAdmin &&
    MANAGED_PREFERENCE_ROLES.includes(roleIdentifier) &&
    (roleIdentifier === 'IMPLEMENTATION_MANAGER' ||
      targetCompanyType === COMPANY_TYPE.SERVICE_PROVIDER)
  );
};

const isSameUserId = (left, right) =>
  !!left &&
  !!right &&
  String(left).toLowerCase() === String(right).toLowerCase();

const getNotificationTypeLabel = (formatMessage, notification) => {
  const typeCode = notification?.notificationTypeCode || notification?.typeCode;
  if (!typeCode) {
    return '';
  }
  return formatMessage({
    id: `NOTIFICATION_TYPE_${typeCode}`,
    defaultMessage: notification?.typeName || notification?.name || typeCode,
  });
};

const getNotificationTypeDescription = (formatMessage, notification) => {
  const typeCode = notification?.notificationTypeCode || notification?.typeCode;
  const description = notification?.description || '';
  if (!typeCode || !description) {
    return description;
  }
  return formatMessage({
    id: `NOTIFICATION_TYPE_${typeCode}_DESCRIPTION`,
    defaultMessage: description,
  });
};

const unreadCountOf = notification =>
  notification?.groupUnreadCount ?? (notification?.readAt ? 0 : 1);

export {
  canManageUserNotificationPreferences,
  getCurrentUserId,
  getNotificationTypeDescription,
  getNotificationTypeLabel,
  isSameUserId,
  unreadCountOf,
};
